export default __webpack_public_path__ + "static/media/head04_zh_cn_pc.004ef277.png";